import {
  Autocomplete,
  FormControlLabel,
  FormLabel,
  Grid,
  MenuItem,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import { Modal } from "../../../components/common/Modal/Modal";
import { ModalHeader } from "../../../components/common/Modal/ModalHeader";
import { ModalBody } from "../../../components/common/Modal/ModalBody";
import { ModalFooter } from "../../../components/common/Modal/ModalFooter";
import { Formik } from "formik";
import { useEffect, useState } from "react";
import { useAllianceStore } from "../../../hooks/useAllianceStore";
import {
  AllianceCreateEdit,
  Region,
} from "../../../types/slices/alliancesType";

export const CreateEditAllianceModal: React.FC<any> = (): JSX.Element | any => {
  const {
    editAlliance,
    openModal,
    setOpenModal,
    isEdit,
    createAlliancestore,
    editAlliancestore,
    getAlliances,
    getRegions,
    setSelectedRegion,
    regions,
    selectedRegion,
  } = useAllianceStore();

  const [data, setData] = useState<AllianceCreateEdit>({
    name: "",
    description: "",
    regions: { id: 0, name: "" },
    region_id: 0,
    logo: "",
    order: 1,
    status: "1",
    type: "Estratégica",
  });

  const validateForm = (values) => {
    let errors: any = {};
    if (!values.name) {
      errors.name = "Nombre es requerido";
    }
    if (values.name && values.name.length > 200) {
      errors.name = "El número máximo de caracteres es 200";
    }
    if (values.type === "Estratégica") {
      if (!values.logo) {
        errors.logo = "La imagen es obligatoria";
      }
      if (!values.order || Number(values.order) <= 0) {
        errors.order = "El orden es requerido y debe ser mayor a 0";
      }
    }
    if (!values.region && !values.region_id) {
      errors.region = "Seleccione una región";
    }
    return errors;
  };

  const onSubmit = async (values) => {
    let params: any = {
      name: values.name,
      description: values.description,
      type: values.type,
      order: values.order,
      status: values.status,
      logo: values.logo,
    };
    if (selectedRegion.id) {
      params = { ...params, region_id: selectedRegion.id };
    } else {
      params = { ...params, region: values.region };
    }
    const method = isEdit
      ? editAlliancestore(editAlliance?.id || 0, params)
      : createAlliancestore(params);
    const response = await method;
    if (response === true) {
      getAlliances();
      setOpenModal(false);
    }
  };

  const clear = () => {
    setData({
      name: "",
      description: "",
      regions: { id: 0, name: "" },
      region_id: 0,
      logo: "",
      order: 1,
      status: "1",
      type: "Estratégica",
    });
  };

  useEffect(() => {
    getRegions();
    if (isEdit && openModal) {
      setData(editAlliance);
      setSelectedRegion(editAlliance.regions || ({} as Region));
    } else {
      setData({
        name: "",
        description: "",
        regions: { id: 0, name: "" },
        region_id: 0,
        logo: "",
        order: 1,
        status: "1",
        type: "Estratégica",
      });
      setSelectedRegion({} as Region);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEdit, editAlliance, openModal]);

  const onChangeRegion = (newValue: Region | null, setFieldValue: any) => {
    if (newValue) {
      setFieldValue("region_id", newValue.id);
      setSelectedRegion(newValue);
    } else {
      setFieldValue("region_id", "");
      setSelectedRegion({} as Region);
    }
  };

  return (
    <>
      <Modal
        open={openModal}
        handleClose={() => {
          clear();
          setOpenModal(false);
        }}
        disableEscapeKeyDown
        disableBackdropClick
        size="sm"
      >
        <ModalHeader
          text={isEdit ? "Editar Alianza" : "Crear Alianza"}
          className="positionElements"
          onCancel={() => {
            clear();
            setOpenModal(false);
          }}
        ></ModalHeader>

        <Formik
          initialValues={data}
          enableReinitialize
          validate={(values) => validateForm(values)}
          onSubmit={onSubmit}
        >
          {({
            values,
            errors,
            touched,
            handleSubmit,
            handleChange,
            setFieldValue,
          }) => {
            return (
              <>
                <ModalBody>
                  <form onSubmit={handleSubmit}>
                    <Grid container>
                      <Grid item container xs={12} spacing={2} sx={{ mt: 2 }}>
                        <Grid item xs={12}>
                          <FormLabel>Nombre:</FormLabel>
                          <TextField
                            id="name"
                            type="text"
                            name="name"
                            fullWidth
                            size="small"
                            value={values.name}
                            onChange={handleChange}
                            error={errors.name && touched.name ? true : false}
                            helperText={
                              errors.name && touched.name ? errors.name : ""
                            }
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <FormLabel>Descripción:</FormLabel>
                          <TextField
                            id="description"
                            name="description"
                            type="text"
                            fullWidth
                            size="small"
                            value={values.description}
                            onChange={handleChange}
                            error={
                              errors.description && touched.description
                                ? true
                                : false
                            }
                            helperText={
                              errors.description && touched.description
                                ? errors.description
                                : ""
                            }
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <FormLabel>Región Existente:</FormLabel>
                          <Autocomplete
                            disablePortal
                            id="combo-box-region"
                            value={selectedRegion}
                            options={regions || []}
                            getOptionLabel={(option) => option.name || ""}
                            isOptionEqualToValue={(option, value) =>
                              option?.id === value?.id
                            }
                            fullWidth
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                size="small"
                                error={errors.region ? true : false}
                              />
                            )}
                            onChange={(e, newValue) => {
                              onChangeRegion(newValue, setFieldValue);
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <FormLabel>Región Nueva:</FormLabel>
                          <TextField
                            id="region"
                            type="text"
                            name="region"
                            fullWidth
                            size="small"
                            value={values.region}
                            onChange={handleChange}
                            error={
                              errors.region && touched.region ? true : false
                            }
                            helperText={
                              errors.region && touched.region
                                ? errors.region
                                : ""
                            }
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <FormLabel>Tipo de Alianza:</FormLabel>
                          <RadioGroup
                            row
                            name="type"
                            value={values.type}
                            onChange={handleChange}
                          >
                            <FormControlLabel
                              value="Estratégica"
                              control={<Radio />}
                              label="Estratégica"
                            />
                            <FormControlLabel
                              value="Comercial"
                              control={<Radio />}
                              label="Comercial"
                            />
                          </RadioGroup>
                        </Grid>

                        <Grid item xs={12}>
                          <FormLabel>Imagen:</FormLabel>
                          <Grid container spacing={2} alignItems="center">
                            <Grid item xs={8}>
                              <TextField
                                id="logo"
                                name="logo"
                                type="file"
                                fullWidth
                                size="small"
                                inputProps={{
                                  accept: "image/png, image/jpeg, image/jpg",
                                }}
                                onChange={(
                                  event: React.ChangeEvent<HTMLInputElement>,
                                ) => {
                                  const file = event.target.files?.[0];
                                  if (file) {
                                    setFieldValue("logo", file);
                                  }
                                }}
                                error={Boolean(errors.logo && touched.logo)}
                                helperText={
                                  errors.logo && touched.logo ? errors.logo : ""
                                }
                              />
                            </Grid>
                            <Grid item xs={4}>
                              {values.logo ? (
                                <img
                                  src={
                                    typeof values.logo === "string"
                                      ? values.logo
                                      : URL.createObjectURL(values.logo)
                                  }
                                  alt="Preview"
                                  style={{
                                    width: "100%",
                                    maxHeight: 120,
                                    objectFit: "contain",
                                    border: "1px solid #ddd",
                                    borderRadius: 4,
                                  }}
                                />
                              ) : (
                                <div
                                  style={{
                                    width: "100%",
                                    height: 120,
                                    border: "1px dashed #ccc",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    color: "#999",
                                    fontSize: 12,
                                  }}
                                >
                                  Sin imagen
                                </div>
                              )}
                            </Grid>
                          </Grid>
                        </Grid>

                        <Grid item xs={12}>
                          <FormLabel>Orden:</FormLabel>
                          <TextField
                            id="order"
                            name="order"
                            type="number"
                            fullWidth
                            size="small"
                            inputProps={{ min: 0 }}
                            value={values.order}
                            onChange={handleChange}
                            error={errors.order && touched.order ? true : false}
                            helperText={
                              errors.order && touched.order ? errors.order : ""
                            }
                          />
                        </Grid>

                        <Grid item xs={12}>
                          <FormLabel>Estado:</FormLabel>
                          <TextField
                            select
                            id="status"
                            name="status"
                            fullWidth
                            size="small"
                            value={values.status}
                            onChange={handleChange}
                            error={
                              errors.status && touched.status ? true : false
                            }
                            helperText={
                              errors.status && touched.status
                                ? errors.status
                                : ""
                            }
                          >
                            <MenuItem value="1">Activo</MenuItem>
                            <MenuItem value="0">Inactivo</MenuItem>
                          </TextField>
                        </Grid>
                      </Grid>
                    </Grid>
                  </form>
                </ModalBody>
                <ModalFooter
                  confirmText={isEdit ? "Actualizar" : "Registrar"}
                  onConfirm={handleSubmit}
                  cancelText={"Cancelar"}
                  onCancel={() => {
                    setOpenModal(false);
                  }}
                  className="modal-confirm-footer"
                />
              </>
            );
          }}
        </Formik>
      </Modal>
    </>
  );
};
